import { useParams } from 'react-router-dom';
import { ScoringProvider } from '../../Context/Scoring.context';
import Solution, { SolutionViewMode } from '../Solution/Solution.component';

export const SampleAssessmentGroupSolutionAssignment: React.FC = () => {
  const { schoolId, rgzId, examinerId } = useParams() as { schoolId: string; rgzId: string; examinerId: string };

  return (
    <ScoringProvider examinerId={examinerId}>
      <Solution
        mode={SolutionViewMode.sampleAssessmentGroupAssignment}
        schoolId={schoolId}
        rgzId={rgzId}
      />
    </ScoringProvider>
  );
};
